import baseRoute from '../baseRoute';

export default `${baseRoute}/materialCompanyMarkupHistory` as const;
